import * as Yup from "yup";

export const createEvent3Schema = Yup.object().shape({
  description: Yup.string().required("Description is Required"),
  price: Yup.number()
    .positive("Price must be greater than zero")
    .required("price is Required"),
  userClassId: Yup.string().required("class name is Required"),
});
